import React from 'react';
import ReactDOM from 'react-dom/client';
import { SocketProvider } from './contexts/SocketContext';
import App from './App';
import './index.css';

/**
 * Sucode Web v2.0.0 - 主入口文件
 * @description 应用初始化、全局Provider配置
 */

// 获取 Socket.io 服务器地址
const socketUrl = import.meta.env.VITE_SOCKET_URL || window.location.origin;

// Socket.io 连接配置
const socketOptions = {
  transports: ['websocket', 'polling'],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  timeout: 20000,
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SocketProvider url={socketUrl} options={socketOptions}>
      <App />
    </SocketProvider>
  </React.StrictMode>
);
